__turbopack_context__.v({
  "container": "AppFooter-module-scss-module__--_9JW__container",
  "footer": "AppFooter-module-scss-module__--_9JW__footer",
});
